import {
  makeStyles,
  TableCell,
  TableCellProps,
  Theme,
} from '@material-ui/core';
import clsx from 'clsx';

const useStyle = makeStyles<Theme>(
  theme => ({
    root: {
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(1),
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      '& p': {
        textOverflow: 'ellipsis',
        display: 'block',
        overflow: 'hidden',
      },
    },
  }),
  { name: 'WbTableCell' },
);

export const WbTableCell: React.FC<TableCellProps> = ({
  className,
  ...props
}) => {
  const { root } = useStyle();
  return <TableCell className={clsx(root, className)} {...props} />;
};
